module.exports = __webpack_public_path__ + "img/Carrousels STARTO_rdv_slide_5.6ec4653d.png";